import {
  Group,
  FabricObject
} from "fabric";
import { createRoundedRect, createRect, createImage, switchShape } from "./shapes";
import { switchClip } from "./clips"
import CustomTextbox from "./customTextbox";

export { createRect, createImage, CustomTextbox, switchShape, switchClip }; // pour le controller


export const toggleOutline = (obj: FabricObject) => {
  const { stroke, fill } = obj
  obj.set({ fill: stroke, stroke: fill })
  obj.strokeWidth = obj.stroke ? 4 / obj.scaleY : 0
}

export async function resizeCanvas(canvas, container) {
  let counter = 1;
  while (
    Math.min(container.clientHeight, container.clientWidth) <= 0 &&
    counter < 20
  ) {
    counter += 1;
    await new Promise((resolve) => setTimeout(resolve, 100));
  }
  // le container/viewport ou 1000 car c'est le max
  let vw = Math.max(
    Math.min(1000, document.documentElement.clientWidth || 0),
    Math.min(1000, window.innerWidth || 0)
  );
  let vh = Math.max(
    Math.min(document.documentElement.clientHeight || 0),
    Math.min(window.innerHeight || 0)
  );
  // le 138 c'est pour ajouter la barre d'insertion
  const xPadding = window.innerWidth >= 768 ? 80 : 20// basé sur les media queries de la modale
  const scaleX = (vw - xPadding) / canvas.width;
  const scaleY = (vh - 138) / canvas.height;
  const zoom = Math.min(scaleX, scaleY); // on prend le plus
  canvas.setZoom(zoom);
  container.style.width = `${canvas.width * zoom}px`;
  container.style.height = `${canvas.height * zoom}px`;
  canvas.renderAll();
}

export function computeDimensions(
  width: number,
  height: number,
  constraint = 1000
) {
  if (width > height) {
    const ratio = constraint / width;
    return [constraint, height * ratio, ratio];
  } else {
    const ratio = constraint / height;
    return [width * ratio, constraint, ratio];
  }
}

export function compactAroundGroup(canvas: any, group: Group) {
  canvas.clear();
  group.left = 0;
  group.top = 0;
  canvas.add(group);
  canvas.width = group.width;
  canvas.height = group.height;
}


export const objectAvaibleControls = [
  {
    type: "rect",
    options: ["outline", "clip", "color"],
  },
  {
    type: "circle",
    options: ["outline", "clip", "color"],
  },
  {
    type: "path",
    options: ["outline", "clip", "color"],
  },
  {
    type: "image",
    options: ["clip"],
  },
  {
    type: "group",
    options: ["clip"],
  },
  {
    type: "i-text",
    options: ["color", "font"],
  },
];



